import { SkillEnum } from '@doltech/utils/lib/constants';
import * as React from 'react';

import { IPolicyHandler } from '../policy/IPolicyHandler';
import { IEventHandler, Policy } from './IEventHandler';

export interface BeforeSubmitTestData {
  remainTimeInSeconds: number;
  remainQuestion: number;
  isSubmitAfterWarning?: boolean;
  isClickSubmitWithinRemainTimeAndQuestion: boolean;
  isSubmitAnyway: boolean;
  isAnswersAllQuestions: boolean;
  lastUserAnswers?: string;
  userAnswers?: string;
  isChangeAfterDoubleCheck?: boolean;
  isDoubleCheck: boolean;
  isClickSubmitOnTimeWithinRemainQuestion: boolean;
  isSubmitOnTime: boolean;
  remainTimeInMinutes: number;
  skill?: SkillEnum;
  isReviewing?: boolean;
  onSubmit: (userExperienceData) => void;
  onCancel?: () => void;
}

export interface BeforeSubmitTestEvent {
  beforeSubmitTest: Policy[];
}

export const useBeforeSubmitTestEvent = (policyHandler: IPolicyHandler) => {
  return React.useMemo(() => new BeforeSubmitTestEventHandler(policyHandler), [policyHandler]);
};

export class BeforeSubmitTestEventHandler
  implements IEventHandler<BeforeSubmitTestEvent, BeforeSubmitTestData>
{
  policyHandler: IPolicyHandler;

  constructor(policyHandler: IPolicyHandler) {
    this.policyHandler = policyHandler;
  }

  async handle(event: BeforeSubmitTestEvent, data: BeforeSubmitTestData): Promise<void> {
    const policies = event.beforeSubmitTest;
    for (const policy of policies) {
      if (this.policyHandler.canHandlePolicy(policy, data)) {
        return this.policyHandler.handlePolicy(policy, data).then(() => {});
      }
    }
    return Promise.resolve();
  }
}
